import { useLatest, useToggle } from "react-use";
import { v4 as uuid } from "uuid";
import {
    onUploadErrorProps,
    onUploadOkProps,
    onUploadProgressProps,
    uploadToPolyVLast,
    uploadToQiNiuGen
} from "../../service/CourseDetail/qiniu";
import { FileProps } from "../../service/CourseDetail/resource";
import lodash from "lodash-es";
import axios from "axios";
import { useState } from "react";
import { checkCourseWare } from "../../service/service";
import { CourseWareTypeList } from "../common";

interface Props {
    nextType?: Record<string, string[]>;
    tokenUrl?: string;
}
export default function useUploadGen({
    nextType = CourseWareTypeList,
    tokenUrl
}: Props) {
    const [fileList, setFileList] = useState<FileProps[]>([]);
    const [uploadLoading, toggleUploadLoading] = useToggle(false);
    const [cancel, setCancel] = useState<any>();
    const FileList = useLatest(fileList);

    type keyType = keyof typeof CourseWareTypeList;
    function getFileType(fileName: string) {
        for (let type of Object.keys(CourseWareTypeList)) {
            if (
                CourseWareTypeList[type as keyType].includes(
                    fileName.split(".").pop()?.toLowerCase() || ""
                )
            ) {
                return type;
            }
        }
    }
    async function onFileChange(Files: File[], cb?: () => void) {
        toggleUploadLoading();
        setFileList(
            Array.from(Files).map(item => {
                return {
                    file: item,
                    uid: uuid(),
                    status: "pending",
                    percent: 0
                };
            })
        );

        function onUploadProgress({
            percent,
            file,
            index
        }: onUploadProgressProps) {
            setFileList((fileList: FileProps[]) => {
                const _list_ = lodash.cloneDeep(fileList);
                _list_[index].percent = percent;
                _list_[index].status = "uploading";
                return _list_;
            });
        }

        function onError({ e, file, index }: onUploadErrorProps) {
            setFileList((fileList: FileProps[]) => {
                const _list_ = lodash.cloneDeep(fileList);
                _list_[index].percent = 100;
                _list_[index].status = "error";
                _list_[index].error = e;
                return _list_;
            });
        }

        function onOk({ file, index, res }: onUploadOkProps) {
            setFileList((fileList: FileProps[]) => {
                const _list_ = lodash.cloneDeep(fileList);
                _list_[index].percent = 100;
                _list_[index].status = "done";
                _list_[index].response = res;
                return _list_;
            });
        }

        const cancelToken = new axios.CancelToken(cancel => {
            setCancel(() => cancel);
        });

        function* upload() {
            let index = 0;
            function setError(e: Error) {
                setFileList((fileList: FileProps[]) => {
                    const _list_ = lodash.cloneDeep(fileList);
                    _list_[index].percent = 0;
                    _list_[index].status = "stop";
                    index++;
                    return _list_;
                });
            }

            async function send(isVideo: boolean, opt: any) {
                try {
                    await checkCourseWare(Files[index], nextType);
                    const r = isVideo
                        ? await uploadToPolyVLast(Files[index], opt)
                        : await uploadToQiNiuGen(
                              Files[index],
                              opt,
                              cancelToken,
                              tokenUrl
                          );
                    index++;
                    return r;
                } catch (e) {
                    setError(e);
                }
            }

            while (index < Files.length) {
                const isVideo = getFileType(Files[index].name) === "video";
                const opt = {
                    onUploadProgress,
                    onError,
                    index,
                    onOk
                };
                yield send(isVideo, opt);
            }

            return new Promise(resolve => resolve("ALL_FILE_OK"));
        }

        const u = upload();
        let gen = null;
        do {
            gen = u.next();
            const res = await gen.value;
            if (res === "ALL_FILE_OK") {
                toggleUploadLoading();
                cb?.();
            }
        } while (!gen.done);
    }

    return {
        cancel,
        uploadLoading,
        fileList: FileList.current,
        onFileChange,
        getFileType
    };
}
